import { faUserGroup as faUserGroupLight } from '@fortawesome/pro-light-svg-icons';
import { faGears, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Skeleton } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Breadcrumbs } from '~/components/molecules/Breadcrumbs';
import { Heading } from '~/components/molecules/Heading';
import { AppUserList } from '~/components/organisms/AppUserList';
import { AppBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { useAppQuery } from '~/lib/api/modules/Apps/hooks/useAppQuery';

export type IAppUsersPageProps = {
  appId: string;
};

export const AppUsersPage: React.FC<IAppUsersPageProps> = (props) => {
  const { appId } = props;
  const { t } = useTranslation();
  const appQuery = useAppQuery({ appId });

  const parentUrl = `/apps/${appId}/settings`;
  const organizationId = appQuery.data?.organization?._id;

  return (
    <>
      <Helmet>
        <title>{t('common.appUsers')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={parentUrl}>
          <FontAwesomeIcon icon={faGears} />
          {t('common.settings')}
        </Breadcrumbs.Action>
      </AppBreadcrumbs>

      <Heading
        title={t('common.appUsers')}
        subtitle={t('AppUsersPage.subtitle')}
        icon={<FontAwesomeIcon icon={faUserGroupLight} />}
        actions={
          <Skeleton loaded={!appQuery.isLoading}>
            <Button
              href={`/apps/${appId}/settings/users/add`}
              icon={<FontAwesomeIcon icon={faPlus} />}
              disabled={!organizationId}
            >
              {t('AppUsersPage.create')}
            </Button>
          </Skeleton>
        }
        previousUrl={parentUrl}
      />
      <AppUserList appId={appId} />
    </>
  );
};
